// @ts-nocheck
/**
 * Show-password dialog — reveals a user's password with copy-to-clipboard.
 * Ported to shadcn Dialog from the previous BSModal.
 *
 * Props contract preserved:
 *   { show, setShow, passwordValue, userId?, setConfirmShowPassword? }
 */
import { useState } from 'react';
import { toast } from 'sonner';
import { Copy, Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';

function RenderShowPasswordModal(props) {
  const [showPassword, setShowPassword] = useState(false);

  const passwordValue = props?.passwordValue?.includes('Password is :')
    ? props.passwordValue.replace('Password is :', '').trim()
    : props?.passwordValue && props.passwordValue !== 'Actual Password is not saved for this user'
      ? props.passwordValue
      : '';

  const notStored = props?.passwordValue === 'Actual Password is not saved for this user';

  const onOpenChange = (next) => {
    props.setShow(next);
    if (!next) {
      if (props.setConfirmShowPassword) props.setConfirmShowPassword(false);
      setShowPassword(false);
    }
  };

  const handleCopy = () => {
    if (!passwordValue) return;
    navigator.clipboard.writeText(passwordValue);
    toast.success('Password copied to clipboard');
  };

  return (
    <Dialog open={props.show} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>User password</DialogTitle>
          <DialogDescription>
            {notStored
              ? 'Actual password is not stored for this user.'
              : 'Handle with care.'}
          </DialogDescription>
        </DialogHeader>

        {!notStored && (
          <div className="space-y-2">
            <label className="text-sm font-medium leading-none">Password</label>
            <div className="relative">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={passwordValue}
                readOnly
                className="pr-20 font-mono"
              />
              <div className="absolute right-1 top-1/2 flex -translate-y-1/2 gap-1">
                <Button
                  type="button"
                  variant="ghost"
                  size="icon"
                  className="h-7 w-7"
                  onClick={() => setShowPassword((v) => !v)}
                  title={showPassword ? 'Hide' : 'Show'}
                >
                  {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </Button>
                <Button
                  type="button"
                  variant="ghost"
                  size="icon"
                  className="h-7 w-7"
                  onClick={handleCopy}
                  title="Copy"
                >
                  <Copy className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default RenderShowPasswordModal;
